<agr-dialog (alt)="alt()" (cancel)="cancel()" (confirm)="confirm()" [data]="data">
  <p>
    {{ 'cart.one-day-delivery.info' | translate }}
  </p>
</agr-dialog>
